import adjustmentEvents from './adjustmentEvents'
import estimates from './estimates'
import CRUD from '../masterData/genericCRUD'

const route = 'agronomy'

export default function agronomy(instance) {
	return {
		/**
		 * CRUD creates the Create, Get, Update and GetALL endpoints;
		 */
		...CRUD(instance, route),
		estimates: estimates(instance),
		adjustmentEvents: adjustmentEvents(instance),
		/**
		 * @param {{ name: string }} body
		 * @param {import("axios").AxiosRequestConfig} config
		 */
		adjust: (id, body, config = {}) => {
			return instance.post(`${route}/${id}`, body, config)
		},

		/**
		 * @param {number} id
		 * @param {import("axios").AxiosRequestConfig} config
		 */
		history: (id, config) => {
			return instance.get(`${route}/${id}/history`, config)
		},
		/**
		 * @param {number} id
		 * @param {import("axios").AxiosRequestConfig} config
		 */
		getBlockYieldAttributes: (id, config) => {
			return instance.get(`${route}/block/${id}/history`, config)
		}
	}
}
